<template>
  <div>
    <fixed-header title="开具发票"></fixed-header>
    <div class="invoice-home__main scroll-touch">
      <section v-for="(item, index) in info" :key="index" class="invoice-home__item">
        <div class="invoice-home__item-title" @click="gotoChoose(item.pathName, item.title, item.mod)">
          <span>{{ item.title }}</span>
          <i :class="['icon', 'invoice_arrow_trans']"></i>
        </div>
      </section>
    </div>
  </div>

</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
import { beforeRouteChange } from 'utils/uploadData';

export default {
  components: { FixedHeader },
  name: 'index',
  data() {
    return {
      info: [
        {
          title: '商城消费开票', isActive: false, pathName: '/invoice/order', mod: 'invoice_order',
        },
        {
          title: '发票抬头设置', isActive: false, pathName: '/invoice/title', mod: 'invoice_title',
        },
        {
          title: '开票历史', isActive: false, pathName: '/invoice/history', mod: 'invoice_history',
        },
      ],
    };
  },
  methods: {
    gotoChoose(pathName, title, mod) {
      MgStat.send('click', {}, {
        mod,
        cont: title,
        direct: 'cntp',
        label: 'btn',
        cntp: 'haowu_invoice',
      });
      beforeRouteChange({ path: pathName }, this);
    },
  },
};
</script>

<style lang="scss">
.invoice-home {
  height: 100%;

  &__main {
    box-sizing: border-box;
    height: 100%;
    position: relative;
    margin-top: 20px;
    background: #ffffff;
    border-top: 1px solid rgba(211, 211, 211, 0.5);
  }

  &__item {
    &-title {
      padding: 10px 30px;
      min-height: 48px;
      height: 90px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid rgba(211, 211, 211, 0.5);

      span {
        font-size: 30px;
        width: 90%;
        height: 42px;
        color: #323232;
      }

      i {
        transition: 0.2s ease-in-out;

        &.active {
          transform: rotate(-180deg);
        }
      }
    }
  }
}
</style>
